/**
 * getFieldsWithGroups
 *
 * @param {Resource} resource Facet resource
 * @param {Set} fields Fields to include
 * Returns: {Array} List consisting of fields and grouped fields sub-lists
 */
export default function getFieldsWithGroups(resource, fields) {
  return resource.meta().template().list()
    .reduce((acc, field) => {
      // ignore fields
      if (!fields.has(field.attr('name'))) {
        return acc;
      }

      const groupName = field.attr('attributeGroupName');

      // add non-grouped fields without any processing
      if (!groupName) {
        acc.fields.push(field);
        return acc;
      }

      // group fields by group name
      if (groupName in acc.fieldGroupNameByIndex) {
        // append to already known group
        acc.fields[acc.fieldGroupNameByIndex[groupName]].push(field);
      } else {
        // create new group
        acc.fields.push([field]);
        acc.fieldGroupNameByIndex[groupName] = acc.fields.length - 1;
      }

      return acc;
    }, {
      fields: [],
      fieldGroupNameByIndex: {},
    }).fields;
}
